import React from 'react';
import { AlertTriangle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';

interface CancelSearchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  playerName?: string;
}

export const CancelSearchDialog: React.FC<CancelSearchDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  playerName
}) => {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2 text-amber-500 mb-2">
            <AlertTriangle className="h-5 w-5" />
            <DialogTitle>Cancel Search</DialogTitle>
          </div>
          <DialogDescription>
            Are you sure you want to cancel the search{playerName ? ` for ${playerName}` : ''}? 
            This action cannot be undone, and all progress will be lost.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4 sm:justify-between">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            No, Continue Search
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleConfirm}
          >
            Yes, Cancel Search
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};